<div class="cta-container">
  @if (isOffRoad) {
    <section class="ride-planning-promo-container">
      <div class="middle">
        <div class="left">
          <img
            class="responsive-img"
            alt="RIDE COMMAND Ride Planning Promo"
            ngSrc="/assets/images/phones.png"
            i18n-alt
          />
        </div>
        <div class="right">
          <div class="plan-ride-container">
            <h1 class="mat-h1" i18n>Improved Ride Planning</h1>
            <p i18n>
              Planning a ride has never been easier with the <strong>NEW Snap-to-Trail</strong> and
              <strong>Snap-to-Track</strong> features brought to you by RIDE COMMAND®
            </p>
            <div class="plan-ride-button-container-home">
              <rdx-plan-ride-button
                [entityType]="'Ride Planning Promo Home'"
                (startRidePlanningClicked)="navigateToUrl('/map/planned-ride/create')"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  }
  @if (showVehicleUpdate$ | async) {
    <section class="updates vehicle-display-bg">
      @if (isIndian) {
        <div class="cta">
          <h1 class="mat-h1" i18n>Apple CarPlay<sup>®</sup> Integration is Here!</h1>
          <p i18n>
            You asked for it, we delivered. Connect your iPhone® after a simple, free software update to your bike.
          </p>
          <a
            id="displayUpdateCTALink"
            class="button primary-button"
            href="javascript:void(0)"
            routerLink="/display"
            rdxAnalytics="Navigate To Update Display From CTA"
            i18n
            >Get the Update</a
          >
          <p i18n>*Apple CarPlay only available in select markets, see Apple website for more</p>
        </div>
      }
      @if (!isIndian) {
        <div class="cta">
          <h1 class="mat-h1" i18n>Get Updates</h1>
          <p i18n>Keep your RIDE COMMAND® display up to date with the latest features and daily trail updates.</p>
          <a
            id="displayUpdateCTALink"
            class="button primary-button"
            href="javascript:void(0)"
            routerLink="/display"
            rdxAnalytics="Navigate To Update Display From CTA"
            i18n
            >Check for Updates</a
          >
        </div>
      }
    </section>
  }
  <rdx-mobile-app-cta />
</div>
